import * as grpcWeb from '@improbable-eng/grpc-web';
import { type LogoutReply, LogoutRequest } from '@aymeric_henry_sr/svelte-proto/identification_pb';
import {
	Identification,
	type IdentificationLogout
} from '@aymeric_henry_sr/svelte-proto/identification_pb_service';

import { GRPC_HOST } from '../../constants/env.constants';
import { unaryTransport } from '../transport';
import { grpcError } from '$lib/utils/grpcError';

const { grpc } = grpcWeb;

export async function logout(): Promise<{ status: grpcWeb.grpc.Code; message: LogoutReply }> {
	return new Promise((resolve, reject) => {
		const req = new LogoutRequest();
		grpc.unary<LogoutRequest, LogoutReply, IdentificationLogout>(Identification.Logout, {
			request: req,
			host: GRPC_HOST,
			transport: unaryTransport,
			onEnd: (res) => {
				const { status, message } = res;
				if (status === grpc.Code.OK && message !== null) {
					resolve({
						status,
						message
					});
				}

				reject(grpcError('Logout', arguments, res));
			}
		});
	});
}
